import { FAVICON_URL } from '../../constants/app'

export default function(domain=''){
    if (!domain)
        return ''

    /* Replaced Internal/Cloudflare rendering with Microlink.io for low RAM usage
    // return `${FAVICON_URL}/${domain}`
    return `${FAVICON_URL}/${encodeURIComponent(domain)}`
    */

    return `https://api.microlink.io/?url=https://${encodeURIComponent(domain)}&embed=logo.url`
}